// Group membership endpoints not covered by the Refine data provider
// (Refine's CRUD is now routed through the Filter API data provider —
// see src/data-providers/filter-api.ts). addMember / removeMember stay
// here because they are sub-resource POST/DELETE actions outside of
// Refine's create/update/delete contract.
import { filterApiFetch } from './filter-api-client';

export const groupsApi = {
  addMember: (vars: { organizationId: string; groupId: string; userId: string }) =>
    filterApiFetch<{ groupId: string; userId: string }>(
      `/v1/organizations/${vars.organizationId}/groups/${vars.groupId}/members`,
      { method: 'POST', body: JSON.stringify({ user_id: vars.userId }) },
    ),
  removeMember: (vars: { organizationId: string; groupId: string; userId: string }) =>
    filterApiFetch<void>(
      `/v1/organizations/${vars.organizationId}/groups/${vars.groupId}/members/${vars.userId}`,
      { method: 'DELETE' },
    ),
};
